import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';

/**
 * CNN LIVE LEGEND - SLIM CONTINUOUS GRADIENT
 * Estilo premium basado en Contrail RF
 */

const GRADIENT_VERTICAL = "linear-gradient(0deg, #feffbcff 0%, #ff4800ff 50%, #962fdbc8 100%)";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row", // Alinea título y barra en fila
  alignItems: "center", // Centra verticalmente
  pointerEvents: "none",
  position: "relative", // Importante para posicionar el Title absoluto
  
  // Necesario para que el Title absoluto sepa respecto a qué posicionarse
  width: "auto", 
}));

const Title = styled(Box)(({ theme }) => ({
  position: 'absolute', // <--- CAMBIO CLAVE
  top: '45%',          // Lo centramos verticalmente
  left: '-30px',        // Lo movemos a la izquierda de la barra
  transform: 'translateY(-50%) rotate(-90deg)', // Centrado vertical y ROTACIÓN
  transformOrigin: 'center center', // Punto de rotación en el centro
  
  // Estilos de texto
  fontSize: '0.7rem',
  fontWeight: 900,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: '#1a237e',
  textShadow: '0 1px 2px rgba(255,255,255,0.8)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  whiteSpace: 'nowrap', // Evita que se rompa en dos líneas
}));

const LegendWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  justifyContent: 'center',
  position: 'relative',
  width: '18px', // Ancho de la barra
  height: '150px',
  marginLeft: '30px',
  marginBottom:'20px' // Espacio para que el título vertical no se corte
}));

const LegendBar = styled(Box)(({ theme }) => ({
  width: "18px",
  height: "150px",
  background: GRADIENT_VERTICAL,
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  border: "1px solid rgba(255,255,255,0.8)",
}));

const LabelsColumn = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "150px",
  padding: '2px 0',
  position: 'absolute',
  left: '30px', // Etiquetas a la derecha de la barra
  width: 'max-content',
}));

const Label = styled(Box)(({ theme }) => ({
  color: "#333",
  fontWeight: 800,
  fontSize: "0.7rem",
  textTransform: "uppercase",
  textShadow: "0 0 3px rgba(255,255,255,1)",
  whiteSpace: 'nowrap',
}));

export default function RiskSelectorCNN_WMS_HEATMAP() {
  return (
    <Container>
      {/* 1. Título Vertical a la izquierda */}
      <Title>
        
        PROBABILITY
      </Title>

      {/* 2. Cuerpo de la leyenda (Barra + Etiquetas) */}
      <LegendWrapper>
        {/* Barra de colores sola */}
        <LegendBar />

        {/* Columna de textos al lado derecho */}
        <LabelsColumn>
          <Label>High</Label>
          <Label>Medium</Label>
          <Label>Low</Label>
        </LabelsColumn>
      </LegendWrapper>
    </Container>
  );
}